import consumer from "./consumer"

export function subscribeToRunUpdates(onUpdate) {
  const subscription = consumer.subscriptions.create("RunChannel", {
    connected() {
      console.log("Connected to RunChannel")
    },

    disconnected() {
      console.log("Disconnected from RunChannel")
    },

    received(data) {
      console.log("Received run update:", data)
      if (onUpdate) {
        onUpdate(data)
      }
    }
  })

  return subscription
}
